import { createFileRoute } from "@tanstack/react-router"
import { UgcAvatarStudioWrapper } from "./-UgcAvatarsPage"

export const Route = createFileRoute("/create/ugc-avatars" as any)({
  component: UgcAvatarStudioWrapper,
})
